export default __webpack_public_path__ + "static/media/FormsAndDocs.7c206572.png";